<template>
    <div>
        <a href="#" class="btn btn-primary btn-icon" v-if="config.view === 'button'" @click.prevent="onProductAdd(productId)"><span>Add to Cart</span>
            <i v-if="loading"><span class="spinner-border spinner-border-sm"></span></i>
            <i v-else class="icon-shopping-bag"></i>
        </a>

        <div class="add-to-cart-container" v-if="config.view === 'full'">
            <div class="add-to-cart-mobile">
                <div class="add-to-cart-mobile__quantity">
                    <SelectMenu v-model.number="formQuantity" :options="quantities" label="I want to use it for"></SelectMenu>
                </div>

                <div class="add-to-cart-mobile__price">
                    <div class="add-to-cart-mobile__price-value">
                        {{ formPrice }}
                    </div>
                    <div class="add-to-cart-mobile__price-info">(VAT incl.)</div>
                    <div v-if="formPriceRule">
                        <span class="badge badge-pill badge-extra-light">save {{ formPriceRule }}</span>
                    </div>
                </div>

                <div class="add-to-cart-mobile__button">
                    <button @click="onProductAdd(productId)" class="btn btn-secondary btn-one-icon"><i class="icon-shopping-bag"><span class="sr-only">Add to Cart</span></i></button>
                </div>
            </div>

            <div class="add-to-cart">
                <div class="add-to-cart__quantity">
                    <SelectMenu v-model.number="formQuantity" :options="quantities" label="I want to use it for"></SelectMenu>
                </div>
                <div class="add-to-cart__price">
                    <div class="add-to-cart__price-value">
                        {{ formPrice }}
                    </div>
                    <div class="add-to-cart__price-info text-sm">(VAT incl.)</div>
                    <div v-if="formPriceRule">
                        <span class="badge badge-pill badge-white">save {{ formPriceRule }}</span>
                    </div>
                </div>
                <div class="add-to-cart__button">
                    <ul class="add-to-cart__button-info list-benefits" v-if="config.supportPeriod">
                        <li>14-day money-back guarantee</li>
                        <li>Future product updates</li>
                        <li>{{ config.supportPeriod }} months support</li>
                    </ul>

                    <button @click="onProductAdd(productId)"><span>Add to Cart</span></button>
                    <div v-if="config.demoUrl">
                        <a :href="config.demoUrl" class="link-icon" target="_blank"><i class="icon-eye"></i> Live demo</a>
                    </div>
                </div>
                <div class="add-to-cart__links" v-if="config.documentationUrl || config.licenseUrl">
                    <a :href="config.documentationUrl" v-if="config.documentationUrl" class="link-icon" target="_blank"><i class="icon-book-open"></i> Documentation</a>
                    <a :href="config.licenseUrl" v-if="config.licenseUrl" class="link-icon"><i class="icon-clipboard"></i> License</a>
                </div>
            </div>
        </div>

        <Modal v-model="showModal" v-if="product !== null" cssClass="product-cart" @close="onModalClose" id="modal-product-cart">
            <template v-slot:alert>
                <div class="alert alert-success">
                    <p>The product has been added to your shopping cart.</p>
                </div>
            </template>

            <template v-slot:body>
                <div class="cart-modal">
                    <div class="cart-modal__main">
                        <template v-if="loading">
                            <Loading :css-class="'loading--cover'"></Loading>
                        </template>

                        <div class="cart-modal__product">
                            <div class="cart-modal__product-row">
                                <div class="flex-grow-1">
                                    <div class="cart-modal__product-name">
                                        {{ product.name }}

                                        <div v-if="modalPriceRule" class="cart-modal__product-name-badge">
                                            <span class="badge badge-pill badge-extra-light">save {{ modalPriceRule }}</span>
                                        </div>
                                    </div>
                                    <div class="cart-modal__product-quantity">
                                        {{ modalQuantity }} Licenses
                                    </div>
                                </div>
                                <div class="ml-auto">
                                    <div class="product-price product-price--block product-price--lg">
                                        <div class="product-price__value">
                                            {{ modalPrice }}
                                        </div>
                                        <div class="product-price__text">
                                            (VAT incl.)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                       <div class="quantity-selection">
                            <div class="cart-modal__headline">Buy More Pay Less</div>
                            <div class="quantity-selection__list">
                                <button type="button"
                                        class="quantity-selection__btn"
                                        v-for="quantity in quantities"
                                        :disabled="quantity.value === modalQuantity"
                                        @click.prevent="onProductQuantityUpdate(quantity)"
                                >
                                    {{ quantity.label }}
                                    <div class="quantity-selection__price"><span
                                            class="quantity-selection__price-value">{{ quantity.price }}</span><span
                                            class="quantity-selection__price-text"
                                            v-if="quantity.value > 1"> / license</span></div>
                                </button>
                            </div>
                        </div>

                        <div class="cart-modal__buttons-group buttons-group buttons-group--no-wrap">
                            <button type="button" class="btn btn-secondary btn-icon" @click="showModal = false"><span class="d-none d-xl-inline">Continue Shopping</span><span class="d-xl-none">Back</span> <i class="icon icon-chevron-left"></i></button>
                            <a :href="config.checkoutUrl" class="btn btn-primary btn-icon" title="Checkout">Checkout <i class="icon icon-shopping-bag"></i></a>
                        </div>
                    </div>
                    <div class="cart-modal__services" v-if="services.length > 0">
                        <div class="cart-modal__headline">Additional Services</div>
                        <div class="cart-modal__services-list">
                            <div class="cart-modal__service" v-for="service in services">
                                <div class="cart-modal__service-inside">
                                    <div class="cart-modal__service-image" v-if="service.icon" v-html="`<i data-icon='&#x${service.icon};'></i>`"></div>
                                    <div class="cart-modal__service-image" v-else-if="service.image">
                                        <img :src="service.image" alt="">
                                    </div>
                                    <div class="cart-modal__service-row">
                                        <div>
                                            <div class="cart-modal__service-name">{{ service.name }}</div>
                                        </div>
                                        <div class="cart-modal__service-price">
                                            <div class="product-price product-price--cart-modal-service">
                                                <div class="product-price__value">{{ service.price }}</div>
                                                <div class="product-price__text">(VAT incl.)</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cart-modal__service-buttons">
                                        <button class="cart-modal__service-buttons-info btn btn-secondary btn-one-icon btn-one-icon--md rounded-circle" :content="service.teaser" v-if="service.teaser" v-tippy="['xs', 'sm'].includes($mq) ? { placement : 'bottom', maxWidth : 260 } : { placement : 'left-start' }">
                                            <i class="icon icon-info"></i>
                                        </button>
                                        <button @click="onServiceRemove(service)"
                                                class="btn btn-primary btn-one-icon btn-one-icon--md rounded-circle" :disabled="loadingServiceId" v-if="service.quantity > 0">
                                            <i class="icon" :class="loadingServiceId === service.id ? 'spinner-border spinner-border-sm' : 'icon-x'"></i>
                                        </button>
                                        <button @click="onServiceAdd(service)"
                                                class="btn btn-primary btn-one-icon btn-one-icon--md rounded-circle" :disabled="loadingServiceId"  v-else>
                                            <i class="icon" :class="loadingServiceId === service.id ? 'spinner-border spinner-border-sm' : 'icon-shopping-bag'"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Modal from '../_components/Modal';
    import SelectMenu from '../_components/SelectMenu';
    import Loading from '../_components/Loading';
    import CartObserver from '../_helpers/cart-observer';
    import { handleAjaxError } from '../_helpers/error-handler';
    import {trackAddToCart, trackRemoveFromCart, trackViewItem} from '../_helpers/analytics';

    export default {
        name: 'ProductCart',
        components: {
            Modal,
            SelectMenu,
            Loading,
        },
        data() {
            return {
                loading: false,
                loadingServiceId: null,
                product: null,
                formQuantity: this.$parent.$config.quantities[0].value,
                modalQuantity: this.$parent.$config.quantities[0].value,
                showModal: false,
                services: [],
            };
        },
        computed: {
            config() {
                return this.$parent.$config;
            },
            productId() {
                return this.config.id;
            },
            quantities() {
                return this.config.quantities;
            },
            modalPriceRule() {
                return this.getQuantityConfig(this.modalQuantity, 'priceRule');
            },
            modalPrice() {
                return this.getQuantityConfig(this.modalQuantity, 'price');
            },
            formPrice() {
                if (this.config.view === 'button') {
                    return null;
                }

                return this.getQuantityConfig(this.formQuantity, 'price');
            },
            formPriceRule() {
                if (this.config.view === 'button') {
                    return null;
                }

                return this.getQuantityConfig(this.formQuantity, 'priceRule');
            }
        },
        methods: {
            getQuantityConfig(value, key) {
                const quantity = this.config.quantities.find(quantity => quantity.value === parseInt(value));

                return quantity ? quantity[key] : null;
            },
            onModalClose() {
                this.product = null;
                this.formQuantity = this.config.quantities[0].value;
                this.modalQuantity = this.config.quantities[0].value;
            },
            onProductAdd(product) {
                this.loading = true;

                this.$http.post(this.config.addProductUrl, { product, quantity: this.formQuantity, services: true }).then(response => {
                    this.product = response.data.product;
                    this.services = response.data.services || [];
                    this.modalQuantity = this.formQuantity;
                    this.showModal = true;

                    CartObserver.update(this);

                    trackAddToCart({
                        id: this.config.id,
                        name: this.config.name,
                        price: this.config.priceRaw,
                        type: this.config.type,
                    });
                }).catch(handleAjaxError).finally(() => {
                    this.loading = false;
                });
            },
            onProductQuantityUpdate(quantity) {
                const previousQuantity = this.modalQuantity;
                const quantityDifference = quantity.value - previousQuantity;
                this.modalQuantity = quantity.value;
                this.loading = true;

                this.$http.post(this.config.updateProductUrl, {
                    product: this.productId,
                    quantity: quantityDifference,
                }).then(() => {
                    CartObserver.update(this);

                    if (quantityDifference > 0) {
                        trackAddToCart({
                            id: this.config.id,
                            name: this.config.name,
                            price: quantity.priceRaw,
                            type: this.config.type,
                            quantity: quantityDifference,
                        });
                    } else {
                        trackRemoveFromCart({
                            id: this.config.id,
                            name: this.config.name,
                            price: quantity.priceRaw,
                            type: this.config.type,
                            quantity: Math.abs(quantityDifference),
                        });
                    }
                }).catch(handleAjaxError).finally(() => {
                    this.loading = false;
                });
            },
            onServiceAdd(product) {
                this.loadingServiceId = product.id;
                this.services.find(service => service.id === product.id).quantity = 1;

                this.$http.post(this.config.addProductUrl, { product: product.id, quantity: 1 }).then(() => {
                    CartObserver.update(this);

                    trackAddToCart({
                        id: product.id,
                        name: product.name,
                        price: product.priceRaw,
                        type: product.type,
                    });
                }).catch(handleAjaxError).finally(() => {
                    this.loadingServiceId = null;
                });
            },
            onServiceRemove(product) {
                this.loadingServiceId = product.id;
                this.services.find(service => service.id === product.id).quantity = 0;

                this.$http.post(this.config.updateProductUrl, { product: product.id, quantity: -1 }).then(() => {
                    CartObserver.update(this);

                    trackRemoveFromCart({
                        id: product.id,
                        name: product.name,
                        price: product.priceRaw,
                        type: product.type,
                    });
                }).catch(handleAjaxError).finally(() => {
                    this.loadingServiceId = null;
                });
            },
        },
        mounted() {
            trackViewItem({
                id: this.config.id,
                name: this.config.name,
                price: this.config.priceRaw,
                type: this.config.type,
            });
        },
    }
</script>
